import React, { useState } from 'react';
import { usePWAInstall } from '../hooks/usePWAInstall.js';
import { Download, Share, PlusSquare, X } from 'lucide-react';

export const PWAInstallButton: React.FC<{ className?: string }> = ({ className = '' }) => {
  const { isInstallable, isInstalled, isIOS, install } = usePWAInstall();
  const [showIOSGuide, setShowIOSGuide] = useState(false);

  // If already running as an installed PWA standalone application, hide the button
  if (isInstalled) {
    return null;
  }

  // Chromium / Android / Desktop flow
  if (isInstallable) {
    return (
      <button
        onClick={install}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-xs font-bold transition shadow-2xs hover:shadow-md cursor-pointer shrink-0 ${className}`}
        title="Instal Aplikasi UIBN Resmi"
      >
        <Download className="w-3.5 h-3.5 text-indigo-200" />
        <span>Instal UIBN</span>
      </button>
    );
  }

  // iOS Safari flow (since beforeinstallprompt is not supported on WebKit/iOS)
  if (isIOS) {
    return (
      <>
        <button
          onClick={() => setShowIOSGuide(true)}
          className={`flex items-center gap-2 px-3 py-1.5 rounded-xl border border-slate-200 hover:border-indigo-300 text-slate-700 hover:text-indigo-600 bg-white text-xs font-bold transition shadow-2xs cursor-pointer shrink-0 ${className}`}
          title="Instal Aplikasi UIBN di iPhone / iPad"
        >
          <Download className="w-3.5 h-3.5 text-indigo-600" />
          <span>Instal iOS</span>
        </button>

        {showIOSGuide && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-xs p-4">
            <div className="w-full max-w-sm rounded-3xl bg-white p-6 shadow-2xl border border-slate-100 flex flex-col space-y-4">
              <div className="flex items-center justify-between">
                <h3 className="font-bold text-slate-900 text-base">Instal di iPhone / iPad</h3>
                <button
                  onClick={() => setShowIOSGuide(false)}
                  className="p-1 rounded-lg hover:bg-slate-100 text-slate-400 hover:text-slate-600 transition"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              <div className="space-y-4 text-xs sm:text-sm text-slate-600 leading-relaxed">
                <p>Nikmati akses instan penuh dari layar beranda Anda dengan memasang aplikasi web ini:</p>
                <ol className="space-y-2 list-decimal list-inside pl-1 text-slate-700 font-medium">
                  <li>
                    Tekan tombol <span className="inline-flex items-center p-1 rounded bg-slate-100 text-slate-800"><Share className="w-3.5 h-3.5 inline" /> Bagikan (Share)</span> di bilah navigasi Safari.
                  </li>
                  <li>
                    Gulir ke bawah dan ketuk pilihan <span className="inline-flex items-center p-1 rounded bg-slate-100 text-slate-800"><PlusSquare className="w-3.5 h-3.5 inline mr-1 text-slate-700" /> Tambah ke Layar Utama (Add to Home Screen)</span>.
                  </li>
                  <li>
                    Tekan tombol <strong className="text-indigo-600">Tambah (Add)</strong> di sudut kanan atas.
                  </li>
                </ol>
              </div>

              <button
                onClick={() => setShowIOSGuide(false)}
                className="w-full rounded-xl bg-indigo-600 hover:bg-indigo-700 py-2.5 text-xs font-bold text-white transition shadow-sm hover:shadow-md cursor-pointer"
              >
                Mengerti
              </button>
            </div>
          </div>
        )}
      </>
    );
  }

  return null;
};
